import { theme, Typography } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import { Flex } from 'zui/Antd';

const { Text } = Typography;

const AssigningTimeViewer = ({ startDate, endDate }) => {
	const {
		token: { fontSizeLG, colorTextLabel }
	} = theme.useToken();

	let validityText = 'Permanent';

	if (startDate && endDate) {
		const start = dayjs(startDate);
		const end = dayjs(endDate);

		const isPermanent = start.year() === 1 && end.year() === 1;

		if (!isPermanent && start.isValid() && end.isValid()) {
			validityText = `${start.format('DD/MM/YYYY hh:mm A')} to ${end.format('DD/MM/YYYY hh:mm A')}`;
		}
	}

	return (
		<Flex vertical gap={4} style={{ width: '100%' }}>
			<Text
				style={{
					fontSize: fontSizeLG,
					color: colorTextLabel,
					lineHeight: '24px'
				}}
			>
				{validityText}
			</Text>
		</Flex>
	);
};

export default AssigningTimeViewer;
